import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@surface-elements/shared/data-access';

@Injectable({ providedIn: 'root' })
export class AuthGuardService {
  auth = inject(AuthService);
  router = inject(Router);

  canActivate(): boolean {
    if (!this.auth.getToken()) {
      this.router.navigateByUrl('/login');
      return false;
    }
    return true;
  }
}
